module.exports = __webpack_public_path__ + "static/media/bad-review3.dfe587b5.png";